'use strict';

angular.module('app.error', [
    'ui.router',
    'gettext',
    'sharecrf-sdk',
]);
